import { useParams, useLocation } from "react-router-dom"
import { checkRegisterCourse } from "../utils/checkRegister"
import lessonService from "../services/lessonService"
import useAuthStore from "../store/authStore"
import { useEffect } from "react"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "sonner"
import { Card } from "../components/ui/card"
import Exercises from "../components/Learning/Exercises"
import useDoExerciseStore from "../store/exerciseStore"
import Result from "../components/Learning/Result"
import PaginationBar from "../components/Learning/PaginationBar"
import useCourseStore from "../store/courseStore"
import { cn } from "../lib/utils"

export default function LessonPage () {
  const navigate = useNavigate()
  const { course_id, lesson_id} = useParams()
  const location = useLocation()
  const query = new URLSearchParams(location.search);
  const pathName = location.pathname
  const exercise_id = query.get('exercise');


  const { user} = useAuthStore()
  const { result} = useDoExerciseStore()
  const { fetchLessonByCourseId} = useCourseStore()

  const [lesson,setLesson] = useState()
  const { lessons} = useCourseStore()
  console.log(lessons)

  const [isRegister,setIsRegister] = useState()

  const fetchLesson = async () => {
    try {
      const response = await lessonService.getLessonByIdAndCourseId(lesson_id,course_id)
      setLesson(response.data)
      // const test = await questionMappingService.getMappingByExerciseId(lesson_id.exercises[])
    } catch (error) {
      toast.error('Lấy dữ liệu thất bại!')
    }
  }



  useEffect(() => {
    if (user) {
        if (checkRegisterCourse(user.enrollments,course_id)) {
          setIsRegister(true)
          fetchLessonByCourseId(course_id)
          fetchLesson()
        }
        else navigate("/")
    }

  }, [user,course_id,lesson_id])


  if (!isRegister || !lesson) return <div>Loading...</div>
  if (exercise_id) return (
    <div className="py-8 space-y-8">
     {
     result &&
     <Result />
     }
      <Exercises />
    </div>
  )
  return (
    <div className="py-8">
      <div className="grid lg:grid-cols-[3fr_1fr] gap-4">
        <Card className="p-4 space-y-8">
          <h1 className="font-[Phudu] text-2xl text-center">
            {lesson.title}
          </h1>
          <div
            dangerouslySetInnerHTML={{ __html: lesson.content }}
            className="p-4"
          />
          <PaginationBar />

        </Card>

        <Card className="p-4 h-max space-y-4">
          <h1 className="font-[Phudu] text-2xl font-bold">Bài tập</h1>
          <p>Ôn bài bằng cách luyện tập!</p>
          <div className="text-center space-y-2">
            {
              lesson.exercises ?
               lesson.exercises.map(exercise => (
                <Card
                className={
                  cn("rounded-full p-4 relative overflow-hidden group cursor-pointer shadow-md hover:shadow-lg transition-shadow duration-300", exercise.is_done ?  "bg-green-400 text-white" : "bg-gray-100 " )}
                key={exercise.exercise_id}
                onClick={
                  () => navigate(`${pathName}?exercise=${exercise.exercise_id}`)
                }
              >
                {/* Tiêu đề bài tập */}
                <div className="transition-transform duration-300 ease-in-out group-hover:translate-x-[100%] text-gray-800 font-medium flex items-center justify-center h-full text-xs">
                  {exercise.exercise_title}
                </div>
                {/* Nội dung hover */}
                <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-blue-500 text-white font-semibold transition-transform duration-300 ease-in-out group-hover:translate-x-0 -translate-x-full rounded-full">
                  Làm bài ngay
                </div>
              </Card>


               )) :
               <p className="text-gray-400">Bài học này không có bài tập</p>
            }


          </div>

        </Card>
      </div>

    </div>
  )
}
